import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.injectTimezoneSubscriptionTags()
  }

  injectTimezoneSubscriptionTags() {
    this.injectHiddenSubscriptionTag(this.timezoneOffsetString);
    this.injectHiddenSubscriptionTag(this.timezoneRegion);
  }

  injectHiddenSubscriptionTag(value) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = "tag";
    input.value = value;
    this.element.appendChild(input);
  }

  get timezoneOffsetInMinutes() {
    return new Date().getTimezoneOffset();
  }

  get timezoneOffsetString() {
    const timezoneOffsetInMinutes = this.timezoneOffsetInMinutes
    const offsetHours = parseInt(timezoneOffsetInMinutes / 60);
    const offsetMinutes = Math.abs(timezoneOffsetInMinutes % 60);

    // Create a string representation, adjusting the sign for conventional display
    const sign = timezoneOffsetInMinutes > 0 ? "-" : "+";
    return `UTC ${sign}${Math.abs(offsetHours).toString().padStart(2, '0')}:${offsetMinutes.toString().padStart(2, '0')}`;
  }

  get timezoneRegion() {
    const utcOffsetHours = -this.timezoneOffsetInMinutes / 60;

    if (utcOffsetHours >= -12 && utcOffsetHours < -4) {
      return 'Americas';
    } else if (utcOffsetHours >= -4 && utcOffsetHours < 5) {
      return 'Europe+Africa';
    } else if (utcOffsetHours >= 5 && utcOffsetHours <= 14) {
      return 'Asia+Pacific';
    } else {
      return 'Unknown'; // In case of an unexpected value
    }
  }
}